import SessionProvider from '@sdk/session/SessionContext';

import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';
import { mapAngularPageToUI } from '@web/newsfeed/Page/NewsfeedPage/newsfeedPageAngular.utils';
import { NewsfeedBridgeState } from '@web/newsfeed/NewsfeedBridgeProvider/newsfeedBridgeProvider.types';
import { NewsfeedBridgeProvider } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';

import { NewsfeedPage } from './NewsfeedPage';

type Props = {
  page: any;
  newsfeedReactBridge: NewsfeedBridgeState;
};

export const NewsfeedPageAngular = ({ page: angularPage, newsfeedReactBridge }: Props) => {
  // util we're sure we can get rid of fetching details from angular side
  // we are passing down the data but we want to make sure
  // the page and it's article reflect react UI model
  const page = mapAngularPageToUI(angularPage);

  return (
    <QueryClientProvider>
      <SessionProvider>
        <NewsfeedBridgeProvider newsfeedBridge={newsfeedReactBridge}>
          <NewsfeedPage page={page}></NewsfeedPage>
        </NewsfeedBridgeProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
};
